import React from "react";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import useTranslationJobs from "../useTranslationJobs.js";
import JobSearchItem from "./JobSearchItem.js";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import ActionButton from "../../common/widgets/ActionButton.js";

export default function SimilarJobsProfile(props) {
  const { jobs, onClose } = props;

  const { t, loading: tLoading } = useTranslationJobs();
  useShowLoader(tLoading, "SimilarJobsProfile");

  const searchResult =
    <JobSearchItem
      searchFilters={jobs}
    />;

  return (
    <div className="SimilarJobsProfile">
      {jobs.map((item, index) =>
        React.cloneElement(searchResult, {
          key: index,
          item,
        }))
      }
      <Row>
        <Col className="modal-actions">
          <ActionButton onClick={onClose}>
            {t("jobs:employers_job_similar_jobs_close_action")}
          </ActionButton>
        </Col>
      </Row>
    </div>
  );
}
